import { SbxCoreService } from './sbxcore.service';
var SbxSessionService = /** @class */ (function () {
    function SbxSessionService(sbxCoreService) {
        this.sbxCoreService = sbxCoreService;
    }
    SbxSessionService.prototype.initialize = function (domain, appKey, baseUrl) {
        if (baseUrl === void 0) { baseUrl = 'https://sbx-server.sbx360.com/api'; }
        this.sbxCoreService.initialize(domain, appKey, baseUrl);
        this.isLogged();
    };
    /**
     * Initialize service with environment
     * @param environment (domain, base_url, appkey)
     */
    SbxSessionService.prototype.initializeWithEnvironment = function (environment) {
        this.sbxCoreService.initialize(environment.domain, environment.appKey, environment.baseUrl);
        this.isLogged();
    };
    /**
     * General User methods
     */
    SbxSessionService.prototype.getCurrentUser = function () {
        return this.sbxCoreService.getCurrentUser();
    };
    SbxSessionService.prototype.isLogged = function () {
        var token = this.getToken();
        if (token) {
            this.sbxCoreService.addHeaderAttr('authorization', 'Bearer ' + token);
            return true;
        }
        return false;
    };
    SbxSessionService.prototype.getToken = function () {
        this.loadToken();
        var token = this.getCurrentUser().token;
        if (token && token !== 'null' && token !== 'undefined') {
            return token;
        }
        return null;
    };
    /**
     * methods that uses cookies
     */
    SbxSessionService.prototype.loadToken = function () {
        this.getCurrentUser().token = window.localStorage.getItem(SbxCoreService.environment.appKey + '_token');
    };
    SbxSessionService.prototype.updateToken = function (token) {
        window.localStorage.setItem(SbxCoreService.environment.appKey + '_token', token);
        this.isLogged();
    };
    SbxSessionService.prototype.updateUser = function (data) {
        var user = this.getCurrentUser();
        user.token = data.token;
        user.id = data.user.id;
        user.name = data.user.name;
        user.login = data.user.login;
        user.email = data.user.email;
        this.updateToken(data.token);
    };
    /**
     * Auth user methods
     */
    SbxSessionService.prototype.login = function (login, password, domain) {
        var _this = this;
        return this.sbxCoreService.login(login, password, domain).then(function (data) {
            if (data.success) {
                _this.updateUser(data);
            }
            return data;
        });
    };
    SbxSessionService.prototype.validate = function (token) {
        var _this = this;
        return this.sbxCoreService.validate(token).then(function (res) { return res; }).then(function (data) {
            if (data.success) {
                data.token = token;
                _this.updateUser(data);
            }
            return data;
        });
    };
    SbxSessionService.prototype.logout = function () {
        window.localStorage.removeItem(SbxCoreService.environment.appKey + '_token');
        this.sbxCoreService.removeHeaderAttr('token');
        this.sbxCoreService.removeCurrentUser();
    };
    SbxSessionService.prototype.signUp = function (login, email, name, password) {
        var _this = this;
        return this.sbxCoreService.signUp(login, email, name, password).then(function (data) {
            if (data.success) {
                _this.updateUser(data);
            }
            return data;
        });
    };
    return SbxSessionService;
}());
export { SbxSessionService };
//# sourceMappingURL=sbxsession.service.js.map